export class FileUploadListOptions {
    autoCloseWhenSuccess?:boolean
    showLog?:boolean
}

export const DefaultFileUploadListOptions:FileUploadListOptions = {
    autoCloseWhenSuccess:true,
    showLog:false,
}